let baseUrl= '';
switch (process.env.NODE_ENV) {
    case 'development':
        baseUrl = '/api' //本地请求的url
        break
    case 'production':
        baseUrl = '/api'
        break;
    case 'testing':
        baseUrl = '/api'
        break;
}
export default baseUrl;


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/setBaseUrl.ts
// module id = 0SDz
// module chunks = 1